<div role="main" class="fc-page">
  <app-header></app-header>
  <app-progress-bar [currentStep]="4"></app-progress-bar>
  <app-meta-bar [referenceId]="service.referenceFileDetails.referenceId || service.getCache('referenceId')"></app-meta-bar>

  <section class="fc-panel">
    <div class="fc-panel-header">
      <h2>File Upload</h2>
    </div>

    @if (notification?.queue?.length > 0) {
      <div class="alerts">
        @for (m of notification.queue; track m; let i = $index) {
          <div [ngClass]="{'alert alert-{{m.type}} alert-dismissable fade in pull-right' : (m.type != 'info'), 'alert alert-info alert-dismissable fade in pull-right': (m.type == 'info')}">
            <button type="button" class="close" (click)="closeNotification(i)" style="font-size: .9em;">x</button>
            <label>{{ m.title }}</label>
            <div>{{ m.body }}</div>
          </div>
        }
      </div>
    }

    <form (ngSubmit)="next()">
      <div class="fc-panel-body">
        <p class="fc-instructions">Please upload all documents requested in your letter.</p>

        @if (showError) {
          <div class="alert alert-danger alert-dismissible fade show" role="alert">
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"
              (click)="showError = !showError"></button>
            <strong>Error </strong>{{ errorMsg }}
          </div>
        }

        <div class="upload-layout">
          <div class="file-uploader-div dropzone" fileDragDrop (filesChangeEmiter)="onFileChange($event)">
            <input type="file" name="file" id="file" (change)="onFileChange($event.target)"
              [accept]="acceptedFiles" multiple style="display:none">
            <div class="upload-content">
              <i class="fa-solid fa-cloud-arrow-up upload-arrow"></i>
              <span class="drag-text">Drag and Drop Files Here</span>
              <span class="or-text">OR</span>
              <label for="file" class="browse-btn">Browse Computer</label>
            </div>
          </div>

          <div class="file-list">
              <div class="mb-2 ">
                <strong>Files Selected For Upload</strong>
              </div>
              <div class="table-div">
                <table class="table">
                  <thead>
                    <tr>
                      <th class="header-text" scope="col">Action</th>
                      <th  class="header-text" scope="col">File Name</th>
                      <th  class="header-text" scope="col">File Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    @if (files.length === 0) {
                      <tr>
                        <td colspan="3" class="file-list-empty">No files selected yet.</td>
                      </tr>
                    }
                    @for (item of files; track item; let i = $index) {
                      <tr>
                        <td><button type="button" class="btn-remove" (click)="removeFile(i)">Remove</button></td>
                        <td title="{{ item.fileName ?? item.name }}">{{ item.fileName ?? item.name }}</td>
                        <td>{{ item.fileSize | fileSize }}</td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            </div>
        </div>

        <div class="accepted-files-toggle">
          <button type="button" class="btn-accepted-files-info" (click)="toggleAcceptedFiles()" [attr.aria-expanded]="showAcceptedFiles">
            <i class="fa-solid fa-circle-info"></i> What files are accepted?
          </button>
          @if (showAcceptedFiles) {
            <div class="accepted-files-panel">
              <strong>Accepted File Types:</strong>
              doc, docx, dcm, pdf, xls, xlsx, jpeg, jpg, bmp, png, tif, tiff, wav, mp3, eml, txt, text/plain
              <br>
              <strong>Maximum file size:</strong> 1.5 GB
            </div>
          }
        </div>

        @if (attestationEnabled) {
          <label class="attestation">
            <span class="checkbox-wrapper" [class.checkbox-force-required-glow]="attestationMissing">
              <input type="checkbox" [(ngModel)]="attestationAccepted" [ngModelOptions]="{standalone: true}" (change)="onAttestationChange()"
              [style.box-shadow]="!attestationAccepted ? '0 0 20px 7px color-mix(in srgb, var(--fc-required-glow-color, #00F5B1) 40%, transparent)' : 'none'"
              style="border-radius: 3px; margin-right: 10px; accent-color: var(--fc-progress-color, #00F5B1);">
            </span>
            <span [innerHTML]="attestationText"></span>
          </label>
        }

        @if (showFileUploadError) {
          <div class="text-danger mt-3">Try again or remove the invalid file and click Submit Files to complete the process.</div>
        }
      </div><!-- end fc-panel-body -->

      <div class="fc-panel-footer fc-panel-footer-between">
        <div class="fc-footer-left">
          <button type="button" class="btn-secondary-action" (click)="back()">Back</button>
          <button type="button" class="btn-secondary-action ms-2" (click)="cancel()">Start Over</button>
        </div>
        <button type="submit" class="btn-enter" [disabled]="isDisabled"
          [ngbTooltip]="isDisabled ? 'You must add a file and complete required attestation to submit.' : null" container="body">
          Submit &gt;
        </button>
      </div>
    </form>
  </section>

  @if (openUploadModal) {
    <app-optimized-file-upload [files]="files" [uploadedFiles]="uploadedFiles" (uploadCompleted)="handleUploadCompleted($event)" (uploadClosed)="closeUploadPopup()"></app-optimized-file-upload>
  }

  <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple"
    [fullScreen]="true">
    <p style="color: white">Please do not Cancel or Refresh page</p>
  </ngx-spinner>

  <app-footer [positionFixed]="false"></app-footer>
</div>
